export enum SchemeTypes
{
    light = 'light',
    dark  = 'dark',
    auto  = 'auto',
}
